<script>
</script>

<svg viewBox="0 0 92 92" xmlns="http://www.w3.org/2000/svg"
	><g filter="url(#a)"><circle cx="45.741" cy="44.741" r="41.741" fill="#292929" /></g><path
		d="M56.973 24c-5.672 0-10.27 4.598-10.27 10.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27S62.645 24 56.973 24m2.634 14.412c-.865 0-1.63-.419-2.11-1.062l.458 2.1h-1.964l.498-2.284a2.634 2.634 0 1 1-2.15-4.152q.18.001.355.026a2.634 2.634 0 1 1 4.47.144q.217-.039.443-.04a2.634 2.634 0 0 1 0 5.268"
		fill="#FF008C"
	/><path
		d="M35.27 24C29.598 24 25 28.598 25 34.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27S40.942 24 35.27 24m2.634 14.602c-.865 0-1.63-.603-2.11-1.246l.458 2.284h-1.964l.498-2.284a2.634 2.634 0 1 1-3.876-3.505h-.003L35.27 28.9l4.204 4.95h-.007a2.63 2.63 0 0 1 1.071 2.117 2.634 2.634 0 0 1-2.634 2.635"
		fill="#0F0"
	/><path
		d="M35.278 45.707c-5.672 0-10.27 4.598-10.27 10.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27-4.598-10.27-10.27-10.27m4.36 10.666c-1.08 1.246-4.36 4.951-4.36 4.951s-3.161-3.739-4.197-4.95c-.524-.614-1.071-1.249-1.071-2.117a2.634 2.634 0 1 1 5.268 0v.13a2.634 2.634 0 0 1 5.268 0c0 .794-.435 1.441-.908 1.986"
		fill="#0FF"
	/><path
		d="M56.973 45.707c-5.672 0-10.27 4.598-10.27 10.27s4.598 10.27 10.27 10.27 10.27-4.598 10.27-10.27-4.598-10.27-10.27-10.27m-.027 15.617-4.317-5.347 4.317-5.347 4.371 5.347z"
		fill="#FF0"
	/><defs
		><filter
			id="a"
			x="0"
			y="0"
			width="91.484"
			height="91.482"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
			><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
				in="SourceAlpha"
				values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				result="hardAlpha"
			/><feOffset dy="1" /><feGaussianBlur stdDeviation="2" /><feComposite
				in2="hardAlpha"
				operator="out"
			/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" /><feBlend
				in2="BackgroundImageFix"
				result="effect1_dropShadow_3664_33813"
			/><feBlend in="SourceGraphic" in2="effect1_dropShadow_3664_33813" result="shape" /></filter
		></defs
	></svg
>
